import { SyncRedactor } from 'redact-pii';

const redactor = new SyncRedactor({
  builtInRedactors: {
    creditCardNumber: { enabled: true },
    emailAddress: { enabled: true },
    ipAddress: { enabled: true },
    password: { enabled: true },
    phoneNumber: { enabled: true },
    streetAddress: { enabled: true },
    username: { enabled: true },
    usSocialSecurityNumber: { enabled: true },

    credentials: { enabled: false },
    digits: { enabled: false },
    names: { enabled: false },
    url: { enabled: false },
    zipcode: { enabled: false },
  },
});

const piiSanitizer = (value: string) => redactor.redact(value);

export default piiSanitizer;
